module.exports = __webpack_public_path__ + "static/media/image20.8ee1d70f.jpg";